import http from './api'

const route = 'app/comercial/vendas4/'

export default {
  showFaturamentoVendas4: (dataInicio, dataFim, select, supervisor, tokenContrato, vendedores, area, rede, classificacao, linhaProducao) => {
    return http.post(route + 'showFaturamentoVendas4', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      area: area,
      rede: rede,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoMesAnoAnterior4: (dataInicio, dataFim, select, supervisor, tokenContrato, vendedores, area, rede, classificacao, linhaProducao) => {
    return http.post(route + 'showFaturamentoMesAnoAnterior4', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      area: area,
      rede: rede,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosFaturamentoMesesAnteriores: (select, supervisor, tokenContrato, vendedores, area, rede, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosFaturamentoMesesAnteriores', {
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      area: area,
      rede: rede,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showFatVolumeMesesDoAno: (select, supervisor, tokenContrato, vendedores, area, rede, classificacao, linhaProducao) => {
    return http.post(route + 'showFatVolumeMesesDoAno', {
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      area: area,
      rede: rede,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },
}
